var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-md": "" } },
                [
                  _c("StepTitle", [_vm._v("Configurar Notificación")]),
                  _c("v-divider"),
                  _c("br"),
                  _c(
                    "div",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  items: _vm.formFields.listaDist.items,
                                  "item-text": "nombre",
                                  "item-value": "id"
                                },
                                model: {
                                  value: _vm.formFields.listaDist.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.listaDist,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.listaDist.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("BuscadorOperacionCrud", {
                                attrs: {
                                  filter:
                                    _vm.gridApiLista &&
                                    _vm.gridApiLista.setQuickFilter.bind(
                                      _vm.gridApiLista
                                    ),
                                  prepend: "person"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                    _c(
                      "div",
                      { attrs: { align: "left" } },
                      [
                        _vm.disabled
                          ? _c("MantenedorGridVerDetalle", {
                              attrs: {
                                "grid-options": _vm.gridOptionsLista,
                                "row-data": _vm.distribucion
                              }
                            })
                          : _c("AsociacionGrid", {
                              attrs: {
                                "grid-options": _vm.gridOptionsLista,
                                "row-data": _vm.distribucion,
                                esEditar: !(_vm.accion === 2) ? false : true
                              }
                            })
                      ],
                      1
                    )
                  ]),
                  _c("br"),
                  _c(
                    "FormFieldsContainer",
                    {
                      attrs: { titulo: "Medio de Notificación", hidden: "true" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md3: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Plataforma GPS",
                              value: 1,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.formFields.medioNotificacion.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.medioNotificacion,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.medioNotificacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md3: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Navegador",
                              value: 2,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.formFields.medioNotificacion.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.medioNotificacion,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.medioNotificacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm12: "", md3: "" } },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              label: "Email",
                              value: 3,
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.formFields.medioNotificacion.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.medioNotificacion,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.medioNotificacion.value"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                    _c(
                      "div",
                      { attrs: { align: "left" } },
                      [
                        _c("v-flex", { attrs: { md12: "" } }, [
                          _c("h2", { staticClass: "h2_title" }, [
                            _vm._v("Calendario")
                          ])
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("v-divider"),
                  _c("CabeceraTabla", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disabled,
                        expression: "!disabled"
                      }
                    ],
                    scopedSlots: _vm._u([
                      {
                        key: "derecha",
                        fn: function() {
                          return [
                            _c("AgregarButton", {
                              on: {
                                click: function($event) {
                                  return _vm.handleAgregarClick()
                                }
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  }),
                  _c(
                    "div",
                    { attrs: { align: "left" } },
                    [
                      _vm.disabled
                        ? _c("MantenedorGridVerDetalle", {
                            attrs: {
                              "grid-options": _vm.gridOptionsCalendario,
                              "row-data": _vm.calendarios
                            }
                          })
                        : _c("AsociacionGrid", {
                            attrs: {
                              "grid-options": _vm.gridOptionsCalendario,
                              "row-data": _vm.calendarios,
                              esEditar: !(_vm.accion === 2) ? false : true,
                              headerCheckbox: false
                            }
                          })
                    ],
                    1
                  ),
                  _c("AgregarCalendarioModal", {
                    attrs: { show: _vm.isModalCrearActivo },
                    on: {
                      cerrar: _vm.handleCierreModalCrud,
                      cerrarBtnGuardar: _vm.handleCierreModalBtnGuardar
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }